import AntIcon from "@/components/icons/AntIcon";
import { useToken } from "@/utils/hooksUtils";
import { Button, Card, Result, Space } from "antd";
import { useLayoutEffect, type Dispatch, type SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router";
import { useHasMultipleAccounts } from "../../modules/auth/hooks";
import { DASHBOARD_ROUTE_PATHS } from "../../modules/dashboard/paths";

export const NotFound = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { token } = useToken();

  // Only AppLayout shows breadcrumbs, and only its Outlet passes the setter.
  const setIsNotFoundPageRendered = useOutletContext<Dispatch<SetStateAction<boolean>> | undefined>();

  const hasMultipleAccounts = useHasMultipleAccounts();

  // Before the paint, so the breadcrumbs never flash above the page.
  useLayoutEffect(() => {
    setIsNotFoundPageRendered?.(true);

    return () => setIsNotFoundPageRendered?.(false);
  }, []);

  return (
    <Card style={{ maxWidth: 600, margin: "0 auto" }}>
      <Result
        status="404"
        title={<span style={{ color: token.colorPrimary }}>{t("pages.notFound.title")}</span>}
        subTitle={
          <>
            <strong>{t("pages.notFound.text")}</strong>
            {hasMultipleAccounts && (
              <span className="margin-top-small" style={{ display: "block" }}>
                {t("pages.notFound.additionalText")}
              </span>
            )}
          </>
        }
        extra={
          <Space className="margin-top-large">
            <Button onClick={() => navigate(-1)}>
              <AntIcon type="double-left" />
              {t("pages.notFound.backAction")}
            </Button>

            <Button onClick={() => navigate(DASHBOARD_ROUTE_PATHS.homepage.to, { replace: true })}>
              {t("pages.notFound.homeAction")}
              <AntIcon type="home" />
            </Button>
          </Space>
        }
      />
    </Card>
  );
};
